import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));

/** UUID v4 ; crypto.randomUUID n'existe qu'en contexte sécurisé (HTTPS ou localhost). */
export const newId = (): string => {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const b = crypto.getRandomValues(new Uint8Array(16));
  b[6] = (b[6]! & 0x0f) | 0x40;
  b[8] = (b[8]! & 0x3f) | 0x80;
  const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
};

/**
 * BUG-032 : un window.open appelé après un await n'est plus rattaché au clic et part au bloqueur de popups.
 * L'onglet est ouvert tout de suite, l'URL (signée, obtenue par l'API) y est posée ensuite.
 * Pas de 'noopener' dans window.open : il renverrait toujours null ; l'opener est coupé à la main.
 */
export const openInNewTab = async (getUrl: () => Promise<string>): Promise<void> => {
  const win = window.open('', '_blank');
  if (win) win.opener = null;
  try {
    const url = await getUrl();
    if (win) win.location.href = url;
    else window.location.href = url; // popup bloquée malgré tout
  } catch (err) {
    win?.close();
    throw err;
  }
};
